export function isNullOrWhitespace(input?: string | null): boolean {
  return !input || !input.trim();
}
